module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zx_nor (1).8abdb9e8.png";